<div class="page-cadastro-swipe">
  <app-card [title]="tituloPagina('produto')" [showHelp]="true" (helpClick)="abrirModalAjuda()"
    [cardClass]="dentroModal ? 'no-border' : null">

    <app-dim-tabswipe #appTab [inputs]="tabs" [form]="form" [class]="dentroModal ? 'no-border' : null">

      <form [formGroup]="form" (ngSubmit)="salvar()">

        <mat-tab-group animationDuration="400ms" [selectedIndex]="appTab.selected.value" mat-stretch-tabs="false"
          mat-align-tabs="start" (selectedIndexChange)="appTab.setTab($event); onTabChange($event)">
          <mat-tab *ngFor="let tab of tabs; let index = index" [label]="tab">
            <ng-template mat-tab-label *ngIf="tab === 'RelacionamentosCustomTab'">
              Relacionamentos
              <i class="fa fa-question-circle help-icon tooltip-cest" ngbTooltip="Relacionamentos com código de entrada"
                container="body" [autoClose]="true" triggers="manual" #t="ngbTooltip" (mouseleave)="t.close()"
                (mouseenter)="t.open()" (click)="t.open()" aria-hidden="true"></i>
            </ng-template>
            <div class="dim-tabswipe-content" *ngIf="tab === 'Geral' || appTab.loadingValidacoes">
              <div class="row">
                <div class="form-group col-sm-3">
                  <div>
                    <span [appDimBoldText]="fieldRequired('servicoProduto')">
                      Tipo de Item
                    </span>
                  </div>
                  <div class="form-radio form-control group" style="border: unset; padding-left: 0px;"
                    [ngClass]="deviceType">
                    <div class="radio radio-inline">
                      <label style="margin-bottom: 0px; cursor: pointer;">
                        <input type="radio" formControlName="servicoProduto" value="P"
                          [disableControl]="loading['disable'] || loading['request']">
                        <i class="helper"></i><span>Produto</span>
                      </label>
                    </div>
                    <div class="radio radio-inline" [ngClass]="deviceType" style="margin-top: 2px;">
                      <label style="margin-bottom: 0px; cursor: pointer;">
                        <input type="radio" formControlName="servicoProduto" value="S"
                          [disableControl]="loading['disable'] || loading['request']">
                        <i class="helper"></i><span>Serviço</span>
                      </label>
                    </div>
                  </div>
                </div>
                <div class="form-group col-sm-2"
                  *ngIf="novoCadastro && this.acoesTela && this.acoesTela['cadastro']?.acesso">
                  <app-dim-checkbox label="Código" formControlName="gerarCodigoAutomatico"
                    tooltip="Marcando essa caixa o sistema irá gerar um código sequencial automaticamente."
                    tooltipIcon="fa fa-question-circle help-icon tooltip-cest"
                    [required]="!form.get('gerarCodigoAutomatico').value">
                  </app-dim-checkbox>

                  <input [disableControl]="loading['request'] || loading['disable'] || form.value.gerarCodigoAutomatico"
                    class="form-control" type="text" formControlName="referenciaItem" placeholder="Código"
                    (change)="changeInputCodigo()">
                  <show-errors [control]="form.controls['referenciaItem']"></show-errors>
                </div>
                <div class="form-group col-sm-2"
                  *ngIf="!novoCadastro && this.acoesTela && this.acoesTela['editar']?.acesso">
                  <label for="" class="text-inverse" [appDimBoldText]="fieldRequired('referenciaItem')">
                    Código
                  </label>
                  <input [disableControl]="loading['request'] || loading['disable']" class="form-control" type="text"
                    formControlName="referenciaItem" placeholder="Código" (change)="changeInputCodigo()">
                  <show-errors [control]="form.controls['referenciaItem']"></show-errors>
                </div>
                <div class="form-group col-sm-7">
                  <label for="form_nome" [appDimBoldText]="fieldRequired('nome')">
                    Nome
                  </label>
                  <input id="form_nome" [disableControl]="loading['request'] || loading['disable']" class="form-control"
                    type="text" formControlName="nome" placeholder="Nome" maxlength="120"
                    (blur)="tratarStringXml('nome', $event)">
                  <show-errors [control]="form.controls['nome']"></show-errors>
                </div>
              </div>
              <div class="row" *ngIf="servicoProduto.value === 'P'">
                <div class="col-sm-4 form-group" style="display: flex;">
                  <div style="width: 100%" rem5 combobox [type]="'classificacao-fiscal'" [loading]="loading"
                    [form]="form" formControlName="classificacaoFiscalID" [modalCadastro]="true"
                    (ngModelChange)="changeNCM($event)" *ngIf="getDynamicOption('classificacaoFiscalID')"
                    [disableControl]="loading['request'] || loading['disable'] || loading['classificacaoFiscal']"
                    [appendTo]="appendTo">
                  </div>
                  <div class="row-icon">
                    <div class="line-adjust">
                      <img src="assets/icon/personalizado/cloud.svg" ngbTooltip="Pesquisar NCM na Dim Cloud"
                        alt="cloud_icon" class="dim-cloud-icon"
                        (click)="subscribeModal('ncmCloud'); abrirModal.abrir('ncmCloud')" aria-hidden="true">
                    </div>
                  </div>
                </div>
                <div class="form-group col-sm-4">
                  <label for="form_unidadeMedidaID" [appDimBoldText]="fieldRequired('unidadeMedidaID')">
                    Unidade de Medida
                  </label>
                  <ng-select id="form_unidadeMedidaID" [appendTo]="appendTo" [loading]="!unidadesMedida"
                    formControlName="unidadeMedidaID" placeholder="Selecione" [items]="unidadesMedida"
                    bindLabel="descricao" bindValue="id"
                    [disableControl]="loading['request'] || loading['disable'] || loading['unidadesMedida']">
                  </ng-select>
                  <show-errors [control]="form.controls['unidadeMedidaID']"></show-errors>
                </div>

                <div class="form-group col-sm-4" *ngIf="getDynamicOption('tipoItemid')">
                  <label for="form_tipoItemid" [appDimBoldText]="fieldRequired('tipoItemid')">
                    Tipo de Produto
                  </label>
                  <ng-select id="form_tipoItemid" [appendTo]="appendTo" [loading]="!tipoItens" formControlName="tipoItemid"
                    placeholder="Selecione" [items]="tipoItens" bindLabel="descricao" bindValue="id"
                    [disableControl]="loading['request'] || loading['disable']">
                  </ng-select>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-sm-10">
                  <label for="form_descricaoComplementar" [appDimBoldText]="fieldRequired('descricaoComplementar')">
                    Descrição Complementar
                  </label>
                  <input id="form_descricaoComplementar" [disableControl]="loading['request'] || loading['disable']"
                    class="form-control" type="text" formControlName="descricaoComplementar"
                    placeholder="Descrição Complementar" maxlength="500"
                    (blur)="tratarStringXml('descricaoComplementar', $event)">
                  <show-errors [control]="form.controls['descricaoComplementar']"></show-errors>
                </div>

                <div class="form-group col-sm-2 check-form">
                  <app-dim-checkbox label="Desativado" formControlName="inativo"></app-dim-checkbox>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-sm-2">
                  <label for="form_precoSaida" [appDimBoldText]="fieldRequired('precoSaida')">
                    Preço Saída
                  </label>
                  <input id="form_precoSaida" class="form-control" placeholder="Preço saída"
                    formControlName="precoSaida"
                    [options]="{ prefix: '', thousands: '.', decimal: ',', precision: precisaoPreco }" currencyMask
                    inputmode="numeric" [disableControl]="loading['request'] || loading['disable']">

                  <show-errors [control]="form.controls['precoSaida']"></show-errors>
                </div>
                <div class="form-group col-sm-2">
                  <app-dim-decimal-input 
                    id="form_custoCompra"
                    [label]="'Custo Compra'" 
                    formControlName="custoCompra"
                    [id]="'custoCompra'">
                  </app-dim-decimal-input>
                  <show-errors [control]="form.controls['custoCompra']"></show-errors>
                </div>
                <div class="form-group col-sm-3" *ngIf="getDynamicOption('peso')">
                  <label for="form_peso" [appDimBoldText]="fieldRequired('peso')">
                    Peso líquido (kg)
                  </label>
                  <input id="form_peso" class="form-control" placeholder="Peso líquido" formControlName="peso"
                    [options]="{ prefix: '', thousands: '.', decimal: ',', precision: 3 }" currencyMask
                    inputmode="numeric" [disableControl]="loading['request'] || loading['disable']">
                  <show-errors [control]="form.controls['peso']"></show-errors>
                </div>
                <div class="form-group col-sm-3" *ngIf="getDynamicOption('peso')">
                  <label for="form_pesoBruto" [appDimBoldText]="fieldRequired('peso')">
                    Peso bruto (kg)
                  </label>
                  <input id="form_pesoBruto" class="form-control" placeholder="Peso bruto" formControlName="pesoBruto"
                    [options]="{ prefix: '', thousands: '.', decimal: ',', precision: 3 }" currencyMask
                    inputmode="numeric" [disableControl]="loading['request'] || loading['disable']">
                  <show-errors [control]="form.controls['pesoBruto']"></show-errors>
                </div>
                  <div class="form-group col-sm-2">
                  <label for="form_quantidadePadraoVolume">
                    Qtde.Padrão p/Volume
                  </label>
                  <input id="form_quantidadePadraoVolume" class="form-control" placeholder="Qtde.Padrão p/Volume" formControlName="quantidadePadraoVolume"
                    [options]="{ prefix: '', thousands: '.', decimal: ',', precision: 3 }" currencyMask
                    inputmode="numeric" [disableControl]="loading['request'] || loading['disable']">
                  <show-errors [control]="form.controls['quantidadePadraoVolume']"></show-errors>
                </div>
              </div>
            </div>
            <div class="dim-tabswipe-content" *ngIf="tab === 'Impostos' || appTab.loadingValidacoes">
              <div class="row">
                <div class="form-group col-sm-12" *ngIf="getDynamicOption('codigoCESTID')">
                  <label for="form_codigoCESTID" [appDimBoldText]="fieldRequired('codigoCESTID')">
                    Código CEST
                    <i class="fa fa-info-circle tooltip-cest"
                      ngbTooltip="Informe a NCM do item para visualizar os códigos disponíveis" container="body"
                      [autoClose]="true" triggers="manual" #t="ngbTooltip" (mouseleave)="t.close()"
                      (mouseenter)="t.open()" (click)="t.open()" aria-hidden="true"></i>
                  </label>
                  <ng-select id="form_codigoCESTID" [appendTo]="appendTo" [loading]="loading['cest']"
                    formControlName="codigoCESTID" placeholder="Selecione" [items]="cests" bindLabel="name"
                    bindValue="id"
                    [disableControl]="loading['request'] || loading['disable'] || !getFormValue('classificacaoFiscalID')">
                  </ng-select>
                  <show-errors [control]="form.controls['codigoCESTID']"></show-errors>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-sm-6" *ngIf="getDynamicOption('origemMercadoria')">
                  <label for="form_origemMercadoria" [appDimBoldText]="fieldRequired('origemMercadoria')">
                    Origem Mercadoria
                  </label>
                  <ng-select id="form_origemMercadoria" [appendTo]="appendTo" [loading]="!origens"
                    formControlName="origemMercadoria" placeholder="Selecione" [items]="origens" bindLabel="descricao"
                    bindValue="id" [disableControl]="loading['request'] || loading['disable']">
                  </ng-select>
                  <show-errors [control]="form.controls['origemMercadoria']"></show-errors>
                </div>

                <div class="form-group col-sm-3" *ngIf="getDynamicOption('cnaeFiscal')">
                  <label for="form_cnaeFiscal" [appDimBoldText]="fieldRequired('cnaeFiscal')">
                    Cnae Fiscal
                  </label>
                  <input id="form_cnaeFiscal" class="form-control" placeholder="Cnae Fiscal"
                    formControlName="cnaeFiscal" [disableControl]="loading['request'] || loading['disable']">
                  <show-errors [control]="form.controls['cnaeFiscal']"></show-errors>
                </div>
              </div>
              <div class="row">
                <div *ngIf="getDynamicOption('uTrib')" class="form-group col-sm-3">
                  <app-dim-input-text label="Unidade Tributável" placeholder="Digite a unidade tributável"
                    formControlName="uTrib" [maxLength]="6"></app-dim-input-text>
                </div>
                <div class="col-sm-3 form-group">
                  <label for="form_fatorConversaoUtrib">Fator Conversão Unid. Trib.</label>
                  <input id="form_fatorConversaoUtrib" class="form-control" placeholder="Fator Conversão Unid. Trib."
                    formControlName="fatorConversaoUtrib" [disableControl]="loading['request'] || loading['disable']"
                    currencyMask [options]="{ allowNegative: false, prefix: '', precision: 4, max: 99999999.9999 }">
                  <show-errors [control]="form.controls['fatorConversaoUtrib']"></show-errors>
                </div>

                <div class="col-sm-6"
                  *ngIf="getDynamicOption('retemPisPassep') || getDynamicOption('retemCofins') || getDynamicOption('retemInss')">
                  <fieldset>
                    <legend>Retenções</legend>
                    <div class="fieldset-content">
                      <div class="form-group m-0 check-form" *ngIf="getDynamicOption('retemPisPassep')">
                        <app-dim-checkbox label="PIS/PASSEP" formControlName="retemPisPassep"></app-dim-checkbox>
                      </div>
                      <div class="form-group m-0 check-form" *ngIf="getDynamicOption('retemCofins')">
                        <app-dim-checkbox label="COFINS" formControlName="retemCofins"></app-dim-checkbox>
                      </div>
                      <div class="form-group m-0 check-form" *ngIf="getDynamicOption('retemInss')">
                        <app-dim-checkbox label="INSS" formControlName="retemInss"></app-dim-checkbox>
                      </div>
                    </div>
                  </fieldset>
                </div>

                <div class="col-sm-6" *ngIf="getDynamicOption('retemCsll')">
                  <fieldset>
                    <legend>Retenções</legend>
                    <div class="fieldset-content">
                      <div class="form-group m-0 check-form">
                        <app-dim-checkbox label="CSLL" formControlName="retemCsll"></app-dim-checkbox>
                      </div>
                      <div class="form-group m-0 check-form" *ngIf="getDynamicOption('retemIss')">
                        <app-dim-checkbox label="ISS" formControlName="retemIss"></app-dim-checkbox>
                      </div>
                      <div class="form-group m-0 check-form" *ngIf="getDynamicOption('retemIR')">
                        <app-dim-checkbox label="IR" formControlName="retemIR"></app-dim-checkbox>
                      </div>
                    </div>
                  </fieldset>
                </div>
              </div>

              <div class="row">
                <app-dim-tabswipe #appTab [inputs]="impostosTabs" class="remove-borders tab-full-size">
                  <mat-tab-group animationDuration="400ms" [selectedIndex]="appTab.selected.value"
                    (selectedIndexChange)="appTab.setTab($event);" mat-stretch-tabs="false" mat-align-tabs="start">
                    <mat-tab *ngFor="let tab of impostosTabs" [label]="tab">
                      <!-- INÍCIO ABA ICMS -->
                      <ng-container *ngIf="tab === 'ICMS'">
                        <div class="row">
                          <div class="form-group col-sm-6" *ngIf="getDynamicOption('aliquotaicmsid')">
                            <label for="form_aliquotaicmsid" [appDimBoldText]="fieldRequired('aliquotaicmsid')">
                              Alíquota ICMS<span *ngIf="estadoEmpresa"> para {{estadoEmpresa}}</span>
                            </label>
                            <ng-select id="form_aliquotaicmsid" [appendTo]="appendTo" [loading]="!aliquotas"
                              formControlName="aliquotaicmsid" placeholder="Selecione" [items]="aliquotasSelecionadas"
                              bindLabel="aliquotaICMS" bindValue="id"
                              [disableControl]="loading['request'] || loading['disable']">

                              <ng-template ng-label-tmp let-item="item">
                                {{aliquotaIcmsSelectLabel(item)}}
                              </ng-template>

                              <ng-template ng-option-tmp let-item="item">
                                <app-temp-option-item [name]="aliquotaIcmsSelectLabel(item)"
                                  (onClick)="subscribeModal('aliquotaIcms'); abrirModal.editar('aliquotaIcms', item.id)">
                                </app-temp-option-item>
                              </ng-template>

                              <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                                <app-temp-not-found-item [searchTerm]="searchTerm"
                                  (onClick)="subscribeModal('aliquotaIcms'); abrirModal.cadastrar('aliquotaIcms', searchTerm)">
                                </app-temp-not-found-item>
                              </ng-template>
                            </ng-select>
                            <show-errors [control]="form.controls['aliquotaicmsid']"></show-errors>
                          </div>

                          <div class="form-group col-sm-6 col-md-3" *ngIf="getDynamicOption('aliquotaICMSCompra')">
                            <label for="form_aliquotaICMSCompra" [appDimBoldText]="fieldRequired('aliquotaICMSCompra')">
                              % ICMS na Compra
                            </label>
                            <input id="form_aliquotaICMSCompra" class="form-control" placeholder="% ICMS na Compra"
                              formControlName="aliquotaICMSCompra"
                              [disableControl]="loading['request'] || loading['disable']" currencyMask
                              [options]="{ prefix: '', thousands: '.', precision: 0 }">
                            <show-errors [control]="form.controls['aliquotaICMSCompra']"></show-errors>
                          </div>
                        </div>
                        <div class="row">
                          <div *ngIf="getDynamicOption('substituicaoTributaria')" class="form-group col-sm-3 d-flex pt-3">
                            <app-dim-checkbox
                              label="Sujeito Subs. Tributária"
                              formControlName="substituicaoTributaria"
                            ></app-dim-checkbox>
                          </div>

                          <div *ngIf="getDynamicOption('tipoDestaqueICMS')">
                            <fieldset>
                              <legend>ICMS</legend>
                              <div class="fieldset-content form-control form-radio group"
                                style="border: unset; padding: 0">
                                <div class="radio radio-inline" [ngClass]="deviceType">
                                  <label style="margin-bottom: 0px; cursor: pointer;">
                                    <input type="radio" formControlName="tipoDestaqueICMS" [value]="0" [disableControl]="loading['disable'] || loading['request']"
                                      (change)="tipoDestaqueICMSChanged()">
                                    <i class="helper"></i><span>Normal</span>
                                  </label>
                                </div>
                                <div class="radio radio-inline" [ngClass]="deviceType">
                                  <label style="margin-bottom: 0px; cursor: pointer;">
                                    <input type="radio" formControlName="tipoDestaqueICMS" [value]="1" [disableControl]="loading['disable'] || loading['request']"
                                      (change)="tipoDestaqueICMSChanged()">
                                    <i class="helper"></i><span>Isento</span>
                                  </label>
                                </div>
                                <div class="radio radio-inline" [ngClass]="deviceType">
                                  <label style="margin-bottom: 0px; cursor: pointer;">
                                    <input type="radio" formControlName="tipoDestaqueICMS" [value]="2" [disableControl]="loading['disable'] || loading['request']"
                                      (change)="tipoDestaqueICMSChanged()">
                                    <i class="helper"></i><span>Não Tributado</span>
                                  </label>
                                </div>
                                <div class="radio radio-inline" [ngClass]="deviceType">
                                  <label style="margin-bottom: 0px; cursor: pointer;">
                                    <input type="radio" formControlName="tipoDestaqueICMS" [value]="3" [disableControl]="loading['disable'] || loading['request']"
                                      (change)="tipoDestaqueICMSChanged()">
                                    <i class="helper"></i><span>Suspenso</span>
                                  </label>
                                </div>
                                <div class="radio radio-inline" [ngClass]="deviceType">
                                  <label style="margin-bottom: 0px; cursor: pointer;">
                                    <input type="radio" formControlName="tipoDestaqueICMS" [value]="4" [disableControl]="loading['disable'] || loading['request']"
                                      (change)="tipoDestaqueICMSChanged()">
                                    <i class="helper"></i><span>Diferido</span>
                                  </label>
                                </div>
                              </div>

                              <div class="grid-beneficios-fiscais">
                                <label for="form_codigoBeneficioFiscal">Código Benefício Fiscal</label>
                                <app-combobox-cbenef-fiscais id="form_codigoBeneficioFiscal" label=""
                                  formControlName="codigoBeneficioFiscal" [customData]="customDataCBenef">
                                </app-combobox-cbenef-fiscais>

                                <label for="form_cCredPresumido">Cód. Benef. Crédito Presumido</label>
                                <ng-select id="form_cCredPresumido" [appendTo]="appendTo"
                                  [loading]="loading['codigosCreditoPresumido']" formControlName="cCredPresumido"
                                  placeholder="Selecione" [items]="codigosCreditoPresumido" bindLabel="descricao"
                                  bindValue="codigo">
                                </ng-select>

                                <label for="form_pCredPresumido">% do Crédito Presumido</label>
                                <div class="input-group" style="width: 150px">
                                  <input id="form_pCredPresumido" type="text" currencyMask
                                    [options]="{prefix: '', precision: 2, allowNegative: false}" class="form-control"
                                    formControlName="pCredPresumido">
                                  <span style="cursor: default" class="input-group-addon">%</span>
                                </div>

                                <ng-container *ngIf="form.get('tipoDestaqueICMS').value === 4"> <!-- Diferido -->
                                  <label for="form_percentualDiferimento">% Diferimento</label>
                                  <div class="input-group" style="width: 150px">
                                    <input id="form_percentualDiferimento" type="text" currencyMask
                                      [options]="{prefix: '', precision: 2, allowNegative: false}" class="form-control"
                                      formControlName="percentualDiferimento">
                                    <span style="cursor: default" class="input-group-addon">%</span>
                                  </div>
                                </ng-container>
                              </div>
                            </fieldset>
                          </div>

                          <div class="form-group col-sm-3 pt-3" *ngIf="getDynamicOption('abaterICMSBasePISCOFINS')">
                            <app-dim-checkbox
                              label="Abater ICMS Base PIS/COFINS"
                              formControlName="abaterICMSBasePISCOFINS"
                            ></app-dim-checkbox>
                          </div>
                        </div>

                        <div class="row mt-3">
                          <div class="col-sm-12 col-xl-6">
                            <h4 class="sub-title m-0 pt-0">
                              Percentuais de redução de alíquotas por UF
                              <i ngbTooltip="Alterações nas porcentagens serão armazenadas ao salvar o produto."
                                class="fa fa-info-circle"></i>
                            </h4>
                            <div *ngIf="listReducoesICMSInterestaduais.length > 0" class="table-responsive">
                              <table class="table mt-3 table-bordered table-striped">
                                <thead>
                                  <tr>
                                    <th style="width: 10%;" scope="col">UF</th>
                                    <th style="width: 1%;" scope="col">Percentual de Redução</th>
                                    <th scope="col">Observação</th>
                                    <th style="width: 1%;">Ações</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr *ngFor="let reducao of listReducoesICMSInterestaduais, let index = index">
                                    <td>{{getSiglaEstado(reducao.estadoId)}}</td>
                                    <td>{{reducao.percentualRedutorICMS}}%</td>
                                    <td>{{reducao.observacoes}}</td>
                                    <td>
                                      <button [disabled]="loading['editando'] || loading['excluindo']"
                                        style="border-radius: 10%"
                                        class="btn btn-info btn-mini waves-effect waves-light" type="button"
                                        placement="left" ngbTooltip="Editar" (click)="editarReducao(reducao, index)">
                                        <i class="icofont icofont-info"></i>
                                      </button>
                                      <button [disabled]="loading['editando'] || loading['excluindo']"
                                        style="border-radius: 10%"
                                        class="btn btn-danger btn-mini waves-effect waves-light" type="button"
                                        placement="left" ngbTooltip="Excluir" (click)="removerReducao(index)">
                                        <i class="ti ti-trash"></i>
                                      </button>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                        <form [formGroup]="formReducao">
                          <div class="row mt-2 col-sm-12 col-xl-6 p-0">
                            <div class="form-group col-md-6 col-xl-2">
                              <label for="form-reducao_UF">Estado</label>
                              <ng-select id="form-reducao_UF" [appendTo]="appendTo" formControlName="estadoId"
                                placeholder="Selecione" [items]="estadosMap" bindLabel="siglaEstado" bindValue="id"
                                [disableControl]="loading['request'] || loading['disable']">
                              </ng-select>
                              <show-errors [control]="formReducao.controls['estadoId']"></show-errors>
                            </div>

                            <div class="form-group col-md-6 col-xl-4">
                              <label for="form-reducao_percentual">Percentual de Redução</label>
                              <div class="input-group">
                                <input id="form-reducao_percentual" formControlName="percentualRedutorICMS" type="text"
                                  currencyMask [options]="{ prefix: '' }" inputmode="numeric" class="form-control">
                                <span style="cursor: default" class="input-group-addon">%</span>
                              </div>
                              <show-errors [control]="formReducao.controls['percentualRedutorICMS']"></show-errors>
                            </div>

                            <div class="form-group col-md-12 col-xl-6 pr-0">
                              <label for="form-reducao_observacoes">Observação</label>
                              <input id="form-reducao_observacoes" formControlName="observacoes" type="text"
                                class="form-control">
                              <div class="text-right">
                                <small
                                  [ngClass]="{'text-danger': formReducao.controls['observacoes'].value?.length > 200}">
                                  {{ formReducao.controls['observacoes'].value?.length || 0 }}/200
                                </small>
                              </div>
                            </div>
                          </div>

                          <div class="row">
                            <div class="custom-btn-row col-sm-4 col-xl-2">
                              <button type="button" class="btn btn-info" (click)="salvarReducao()">
                                <app-loading [loading]="loading['salvando']"
                                  [texto]="loading['editando'] ? 'Editar Redução' : 'Salvar Redução'"
                                  [textoLoading]="'Salvando'" [icone]="'icofont icofont-save'">
                                </app-loading>
                              </button>
                              <button *ngIf="loading['editando']"
                                class="btn btn-danger btn-mini botao-cancelar-edicao-reducao" (click)="cancelarEdicao()"
                                type="button" ngbTooltip="Cancelar edição da redução">
                                <i class="ti ti-close"></i>
                              </button>
                            </div>
                          </div>
                        </form>
                      </ng-container>
                      <!-- FIM ABA ICMS -->

                      <!-- INÍCIO ABA IPI -->
                      <ng-container *ngIf="tab === 'IPI'">
                        <div class="row">
                          <div class="form-group col-sm-6" *ngIf="getDynamicOption('ipiSituacaoTributaria')">
                            <label for="form_ipiSituacaoTributaria"
                              [appDimBoldText]="fieldRequired('ipiSituacaoTributaria')">
                              Situacao Tributaria IPI
                            </label>
                            <ng-select id="form_ipiSituacaoTributaria" [appendTo]="appendTo"
                              [loading]="!situacaoTributariaIPI" formControlName="ipiSituacaoTributaria"
                              placeholder="Selecione" [items]="situacaoTributariaIPI" bindLabel="name" bindValue="id"
                              [disableControl]="loading['request'] || loading['disable']">
                            </ng-select>
                            <show-errors [control]="form.controls['ipiSituacaoTributaria']"></show-errors>
                          </div>
                          <div class="form-group col-sm-6" *ngIf="getDynamicOption('aliquotaipi')">
                            <label for="form_aliquotaipi" [appDimBoldText]="fieldRequired('aliquotaipi')">
                              Alíquota IPI
                            </label>
                            <input id="form_aliquotaipi" [disableControl]="loading['request'] || loading['disable']"
                              class="form-control" type="text" formControlName="aliquotaipi" placeholder="Alíquota IPI"
                              [options]="optionsAliquota" currencyMask inputmode="numeric">
                            <show-errors [control]="form.controls['aliquotaipi']"></show-errors>
                          </div>
                        </div>
                        <div class="row">
                          <div class="form-group col-sm-6" *ngIf="getDynamicOption('extipi')">
                            <label for="form_extipi" [appDimBoldText]="fieldRequired('extipi')">
                              EXT IPI
                            </label>
                            <input id="form_extipi" [disableControl]="loading['request'] || loading['disable']"
                              digitOnly minlength="2" maxlength="3" class="form-control" type="text"
                              formControlName="extipi" placeholder="EXT IPI">
                            <show-errors [control]="form.controls['extipi']"></show-errors>
                          </div>
                          <div class="form-group col-sm-6" *ngIf="getDynamicOption('ipiValorUnitario')">
                            <label for="form_ipiValorUnitario" [appDimBoldText]="fieldRequired('ipiValorUnitario')">
                              IPI Valor Unitário
                            </label>
                            <input id="form_ipiValorUnitario" class="form-control" placeholder="IPI Valor Unitário"
                              formControlName="ipiValorUnitario" currencyMask inputmode="numeric"
                              [disableControl]="loading['request'] || loading['disable']">
                            <show-errors [control]="form.controls['ipiValorUnitario']"></show-errors>
                          </div>
                        </div>
                      </ng-container>
                      <!-- FIM ABA IPI -->

                      <!-- INÍCIO ABA PIS/COFINS -->
                      <ng-container *ngIf="tab === 'PIS/COFINS'">
                        <div class="row">
                          <div class="form-group col-sm-6" *ngIf="getDynamicOption('pisSituacaoTributaria')">
                            <label for="form_pisSituacaoTributaria"
                              [appDimBoldText]="fieldRequired('pisSituacaoTributaria')">
                              Situação Tributária PIS
                            </label>
                            <ng-select id="form_pisSituacaoTributaria" [appendTo]="appendTo"
                              [loading]="!situacaoTributariaPis" formControlName="pisSituacaoTributaria"
                              placeholder="Selecione" [items]="situacaoTributariaPis" bindLabel="name" bindValue="id"
                              [disableControl]="loading['request'] || loading['disable']"
                              (change)="changedCstPisCofins('pis', $event)">
                            </ng-select>
                            <show-errors [control]="form.controls['pisSituacaoTributaria']"></show-errors>
                          </div>
                          <div class="form-group col-sm-3" *ngIf="getDynamicOption('pis')">
                            <label for="form_pis" [appDimBoldText]="fieldRequired('pis')">
                              Alíquota PIS
                            </label>
                            <input id="form_pis"
                              [disableControl]="loading['request'] || loading['disable'] || loading['pis']"
                              class="form-control" type="text" formControlName="pis" placeholder="Alíquota pis"
                              [options]="optionsAliquota" currencyMask inputmode="numeric">
                            <show-errors [control]="form.controls['pis']"></show-errors>
                          </div>
                          <div class="form-group col-sm-3" *ngIf="getDynamicOption('pisValorUnitario')">
                            <label for="form_pisValorUnitario" [appDimBoldText]="fieldRequired('pisValorUnitario')">
                              PIS Valor Unitário
                            </label>
                            <input id="form_pisValorUnitario" class="form-control" placeholder="pis Valor Unitário"
                              formControlName="pisValorUnitario" currencyMask inputmode="numeric"
                              [disableControl]="loading['request'] || loading['disable']">
                            <show-errors [control]="form.controls['pisValorUnitario']"></show-errors>
                          </div>
                        </div>

                        <div class="row">
                          <div class="form-group col-sm-6" *ngIf="getDynamicOption('cofinsSituacaoTributaria')">
                            <label for="form_cofinsSituacaoTributaria"
                              [appDimBoldText]="fieldRequired('cofinsSituacaoTributaria')">
                              Situação Tributária COFINS
                            </label>
                            <ng-select id="form_cofinsSituacaoTributaria" [appendTo]="appendTo"
                              [loading]="!situacaoTributariaCofins" formControlName="cofinsSituacaoTributaria"
                              placeholder="Selecione" [items]="situacaoTributariaCofins" bindLabel="name" bindValue="id"
                              [disableControl]="loading['request'] || loading['disable']"
                              (change)="changedCstPisCofins('cofins', $event)">
                            </ng-select>
                            <show-errors [control]="form.controls['cofinsSituacaoTributaria']"></show-errors>
                          </div>
                          <div class="form-group col-sm-3" *ngIf="getDynamicOption('cofins')">
                            <label for="form_cofins" [appDimBoldText]="fieldRequired('cofins')">
                              Alíquota COFINS
                            </label>
                            <input id="form_cofins"
                              [disableControl]="loading['request'] || loading['disable'] || loading['cofins']"
                              class="form-control" type="text" formControlName="cofins" placeholder="Alíquota COFINS"
                              [options]="optionsAliquota" currencyMask inputmode="numeric">
                            <show-errors [control]="form.controls['cofins']"></show-errors>
                          </div>
                          <div class="form-group col-sm-3" *ngIf="getDynamicOption('cofinsValorUnitario')">
                            <label for="form_cofinsValorUnitario"
                              [appDimBoldText]="fieldRequired('cofinsValorUnitario')">
                              Valor Unitário COFINS
                            </label>
                            <input id="form_cofinsValorUnitario" class="form-control"
                              placeholder="Valor Unitário COFINS" formControlName="cofinsValorUnitario" currencyMask
                              inputmode="numeric" [disableControl]="loading['request'] || loading['disable']">
                            <show-errors [control]="form.controls['cofinsValorUnitario']"></show-errors>
                          </div>
                        </div>

                        <div class="row">
                          <div class="form-group col-sm-6" *ngIf="getDynamicOption('codigoissqn')">
                            <label for="form_codigoissqn" [appDimBoldText]="fieldRequired('codigoissqn')">
                              Código ISSQN
                            </label>
                            <ng-select id="form_codigoissqn" [appendTo]="appendTo" [loading]="!servicosISSQN"
                              formControlName="codigoissqn" placeholder="Selecione" [items]="servicosISSQN"
                              bindLabel="name" bindValue="id"
                              [disableControl]="loading['request'] || loading['disable']">
                            </ng-select>
                            <show-errors [control]="form.controls['codigoissqn']"></show-errors>
                          </div>
                          <div class="form-group col-sm-3" *ngIf="getDynamicOption('aliquotaissqn')">
                            <label for="form_aliquotaissqn" [appDimBoldText]="fieldRequired('aliquotaissqn')">
                              Alíquota ISSQN
                            </label>
                            <input id="form_aliquotaissqn" [disableControl]="loading['request'] || loading['disable']"
                              class="form-control" type="text" formControlName="aliquotaissqn"
                              placeholder="Alíquota ISSQN" [options]="optionsAliquota" currencyMask inputmode="numeric">
                            <show-errors [control]="form.controls['aliquotaissqn']"></show-errors>
                          </div>
                          <div class="form-group col-sm-3" *ngIf="getDynamicOption('formaTributacaoServicoISSQN')">
                            <label for="form_formaTributacaoServicoISSQN"
                              [appDimBoldText]="fieldRequired('formaTributacaoServicoISSQN')">
                              Forma Tributação Serviço ISSQN
                            </label>
                            <ng-select id="form_formaTributacaoServicoISSQN" [appendTo]="appendTo"
                              [loading]="!tipoTributacaoServicos" formControlName="formaTributacaoServicoISSQN"
                              placeholder="Selecione" [items]="tipoTributacaoServicos" bindLabel="name" bindValue="id"
                              [disableControl]="loading['request'] || loading['disable']">
                            </ng-select>
                            <show-errors [control]="form.controls['formaTributacaoServicoISSQN']"></show-errors>
                          </div>
                        </div>

                        <div class="row">
                          <div class="form-group col-sm-6" *ngIf="getDynamicOption('tipoBaseCalculoPISCOFINS')">
                            <label for="form_tipoBaseCalculoPISCOFINS"
                              [appDimBoldText]="fieldRequired('tipoBaseCalculoPISCOFINS')">
                              Base de Cálculo de PIS e COFINS
                            </label>
                            <ng-select id="form_tipoBaseCalculoPISCOFINS" [items]="tiposBaseCalculoPISCOFINS"
                              bindLabel="label" bindValue="value" formControlName="tipoBaseCalculoPISCOFINS"
                              placeholder="Base de Cálculo de PIS e COFINS" [appendTo]="appendTo"
                              [disableControl]="loading['request'] || loading['disable']"></ng-select>
                            <show-errors [control]="form.controls['tipoBaseCalculoPISCOFINS']"></show-errors>
                          </div>
                        </div>
                      </ng-container>
                      <!-- FIM ABA PIS/COFINS -->
                    </mat-tab>
                  </mat-tab-group>
                </app-dim-tabswipe>
              </div>
            </div>
            <div class="dim-tabswipe-content"
              *ngIf="(tab === 'Específicos' || appTab.loadingValidacoes) && !(form.get('servicoProduto').value === 'S')">
              <div class="row">
                <div class="form-group col-sm-12">
                  <label for="form_codigoANP" [appDimBoldText]="fieldRequired('codigoANP')">
                    Código ANP
                  </label>
                  <ng-select id="form_codigoANP" [appendTo]="appendTo" [loading]="!tipoProdutoANPMap"
                    formControlName="codigoANP" placeholder="Selecione" [items]="tipoProdutoANPMap" bindLabel="name"
                    bindValue="id" [disableControl]="loading['request'] || loading['disable']">
                  </ng-select>
                  <show-errors [control]="form.controls['codigoANP']"></show-errors>
                </div>
              </div>

              <div class="row" *ngIf="form.get('codigoANP').value && icmsMonoEnabled">
                <div class="form-group col-sm-4">
                  <label>UF de Origem</label>
                  <ng-select [appendTo]="appendTo" formControlName="cUFOrig" placeholder="Selecione" [items]="estadosMap"
                    bindLabel="nome" bindValue="id">
                  </ng-select>
                </div>

                <div class="form-group col-md-6 col-xl-2">
                  <label for="form-pOrig">Percentual Originário</label>
                  <div class="input-group">
                    <input id="form-pOrig" formControlName="pOrig" type="text"
                      currencyMask [options]="{ prefix: '' }" inputmode="numeric" class="form-control">
                    <span style="cursor: default" class="input-group-addon">%</span>
                  </div>
                  <show-errors [control]="formReducao.controls['pOrig']"></show-errors>
                </div>
              </div>

              <div *ngIf="form.get('codigoANP').value && icmsMonoEnabled" class="row form-group">
                <div class=" col-sm-12">
                  <app-dim-radio-group id="combGLP" formControlName="combGLP" label="Tipo de produto da ANP"
                    [options]="codigoANPOptions" (change)="handleCombGLPChange()"></app-dim-radio-group>
                  <div *ngIf="form.get('combGLP').value === 0" class="row ml-2">
                    <div class="col-sm-12 col-md-6 col-lg-4">
                      <app-dim-input-text label="% Gás Nacional" formControlName="comb_pGNn" maskType="quantity"
                        [maxValue]="100" [maskPrecision]="4" [showErrors]="true" [defaultValue]="0" [showErrors]="true"
                        showErrorsMessage="Informe um valor entre 0 e 100"></app-dim-input-text>
                      <show-errors [control]="form.get('comb_pGNn')"></show-errors>
                    </div>
                    <div class="col-sm-12 col-md-6 col-lg-4">
                      <app-dim-input-text label="% Gás Importado" formControlName="comb_pGNi" maskType="quantity"
                        [maxValue]="100" [maskPrecision]="4" [showErrors]="true" [defaultValue]="0" [showErrors]="true"
                        showErrorsMessage="Informe um valor entre 0 e 100"></app-dim-input-text>
                      <show-errors [control]="form.get('comb_pGNi')"></show-errors>
                    </div>
                    <div class="col-sm-12 col-md-6 col-lg-4">
                      <app-dim-input-text label="% Gás Derivado de Petróleo" formControlName="comb_pGLP"
                        maskType="quantity" [maskPrecision]="4" [maxValue]="100" [showErrors]="true" [defaultValue]="0"
                        [showErrors]="true" showErrorsMessage="Informe um valor entre 0 e 100"></app-dim-input-text>
                      <show-errors [control]="form.get('comb_pGLP')"></show-errors>
                    </div>
                    <div class="col-sm-12 col-md-6">
                      <app-dim-input-text label="Valor de Partida s/ICMS" formControlName="comb_vPart"
                        maskType="currency" maskPrefix="R$ " [defaultValue]="0"></app-dim-input-text>
                    </div>
                  </div>
                  <div *ngIf="[0, 1].includes(form.get('combGLP').value)" class="row">
                    <div class="col-sm-12">
                      <app-dim-radio-group id="tipoCombustivel" formControlName="tipoCombustivel" label=""
                        [options]="icmsMonoCSTsOptionsFilter"></app-dim-radio-group>
                      <div class="row ml-2">
                        <div *ngIf="[1, 2, 3].includes(form.get('tipoCombustivel').value)" class="col-sm-12 col-md-6">
                          <app-dim-input-text label="Alíquota Fixa (Ad Rem)" formControlName="aliquotaFixaAdRem"
                            maskType="currency" maskPrefix="R$ " [maskPrecision]="4"
                            [defaultValue]="0"></app-dim-input-text>
                        </div>
                        <div *ngIf="[1, 2, 3, 4].includes(form.get('tipoCombustivel').value)"
                          class="col-sm-12 col-md-6">
                          <app-dim-input-text label="Índice Mistura Biodiesel" formControlName="indiceMisturaBio"
                            maskType="quantity" maskPrefix="" [maskPrecision]="4" [defaultValue]="0" [maxValue]="100"
                            [showErrors]="true" showErrorsMessage="Informe um valor entre 0 e 100"></app-dim-input-text>
                        </div>
                        <div *ngIf="form.get('tipoCombustivel').value === 2" class="col-sm-6">
                          <app-dim-input-text label="% Red. Alíquota Ad Rem" formControlName="percRedAdRem"
                            maskType="quantity" maskPrefix="" [maskPrecision]="2" [defaultValue]="0" [maxValue]="100"
                            [showErrors]="true" showErrorsMessage="Informe um valor entre 0 e 100"></app-dim-input-text>
                        </div>
                        <div *ngIf="form.get('tipoCombustivel').value === 3" class="col-sm-6">
                          <app-dim-input-text label="% Diferimento ICMS" formControlName="percDifMono"
                            maskType="quantity" maskPrefix="" [maskPrecision]="2" [defaultValue]="0" [maxValue]="100"
                            [showErrors]="true" showErrorsMessage="Informe um valor entre 0 e 100"></app-dim-input-text>
                        </div>
                        <div *ngIf="form.get('tipoCombustivel').value === 4" class="col-sm-6">
                          <app-dim-input-text label="Alíquota Retenção (Ad Rem)" formControlName="aliquotaRetidaAdRem"
                            maskType="currency" maskPrefix="R$ " [maskPrecision]="2"
                            [defaultValue]="0"></app-dim-input-text>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <hr />
              <div class="row">
                <div class="form-group col-sm-6">
                  <label for="form_codigoAnvisa" [appDimBoldText]="fieldRequired('codigoAnvisa')">
                    Código Anvisa
                  </label>
                  <input id="form_codigoAnvisa" [disableControl]="loading['request'] || loading['disable']"
                    class="form-control" type="text" formControlName="codigoAnvisa" placeholder="Código Anvisa">
                  <show-errors [control]="form.controls['codigoAnvisa']"></show-errors>
                </div>
                <div class="form-group col-sm-6">
                  <label for="form_precoMaximoConsumidor" [appDimBoldText]="fieldRequired('precoMaximoConsumidor')">
                    Preço Máximo Consumidor
                  </label>
                  <input id="form_precoMaximoConsumidor" class="form-control" placeholder="Preço Máximo Consumidor"
                    formControlName="precoMaximoConsumidor" currencyMask inputmode="numeric"
                    [disableControl]="loading['request'] || loading['disable']">
                  <show-errors [control]="form.controls['precoMaximoConsumidor']"></show-errors>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-sm-6">
                  <label for="form_indicadorProducao" [appDimBoldText]="fieldRequired('indicadorProducao')">
                    Indicador escala
                  </label>
                  <ng-select id="form_indicadorProducao" [appendTo]="appendTo" [loading]="!indicadorProducao"
                    formControlName="indicadorProducao" placeholder="Selecione" [items]="indicadorProducao"
                    bindLabel="descricao" bindValue="codigo"
                    [disableControl]="loading['request'] || loading['disable']">
                  </ng-select>
                  <show-errors [control]="form.controls['indicadorProducao']"></show-errors>
                </div>
                <div class="form-group col-sm-6">
                  <label for="form_cnpjFabricante" [appDimBoldText]="fieldRequired('cnpjFabricante')">
                    Cnpj Fabricante
                  </label>
                  <input id="form_cnpjFabricante" class="form-control" placeholder="Cnpj Fabricante"
                    formControlName="cnpjFabricante"
                    [mask]="edicaoMascaras.retornaMascaraCpfCnpj(this.form.value.cnpj, 2)"
                    [disableControl]="loading['request'] || loading['disable']">
                  <show-errors [control]="form.controls['cnpjFabricante']"></show-errors>
                </div>
              </div>
              <div class="row">

                <div class="form-group col-sm-6">
                  <label for="form_cEAN" [appDimBoldText]="fieldRequired('cEAN')">
                    EAN
                  </label>
                  <input id="form_cEAN" class="form-control" placeholder="EAN" formControlName="cEAN"
                    [disableControl]="loading['request'] || loading['disable']">
                  <show-errors [control]="form.controls['cEAN']"></show-errors>
                </div>
                <div class="form-group col-sm-6">
                  <label for="form_cEANTributavel" [appDimBoldText]="fieldRequired('cEANTributavel')">
                    EAN Tributável
                  </label>
                  <input id="form_cEANTributavel" class="form-control" placeholder="EAN Tributável"
                    formControlName="cEANTributavel" [disableControl]="loading['request'] || loading['disable']">
                  <show-errors [control]="form.controls['cEANTributavel']"></show-errors>
                </div>
              </div>
            </div>
            <div class="dim-tabswipe-content" *ngIf="tab === 'Autos' || appTab.loadingValidacoes">
              <form [formGroup]="formAuto">
                <div class="row">
                  <div class="form-group col-sm-4 d-flex align-items-center">
                    <div class="w-100">
                      <label for="form_renavam" class="label-required">Renavam</label>
                      <input id="form_renavam" type="text" class="form-control" maxlength="11" formControlName="renavam"
                        [disabled]="loading['request'] || loading['disabled']">
                      <show-errors [control]="formAuto.controls['renavam']"></show-errors>
                    </div>
                    <div class="row-icon">
                      <div class="line-adjust">
                        <img src="assets/icon/personalizado/cloud.svg" alt="cloud_icon"
                          ngbTooltip="Pesquisar Renavam no Dim Cloud" (click)="buscarDimCloudRenavam()"
                          class="dim-cloud-icon ml-2 line-adjust" aria-hidden="true">
                      </div>
                    </div>
                  </div>
                  <div class="form-group col-sm-4">
                    <label for="form_estadoId" class="label-required">Estado de licenciamento</label>
                    <ng-select id="form_estadoId" [appendTo]="appendTo" formControlName="estadoId" [items]="estadosMap"
                      bindLabel="siglaEstado" bindValue="id"
                      [disableControl]="loading['request'] || loading['disable']">
                    </ng-select>
                    <show-errors [control]="formAuto.controls['estadoId']"></show-errors>
                  </div>
                  <div class="form-group col-sm-4 d-flex align-items-center">
                    <div class="w-100">
                      <label for="form_placa" class="label-required">Placa</label>
                      <input id="form_placa" type="text" maxlength="7" class="form-control" formControlName="placa"
                        [disabled]="loading['request'] || loading['disabled']">
                      <show-errors [control]="formAuto.controls['placa']"></show-errors>
                    </div>
                    <div class="row-icon">
                      <div class="line-adjust">
                        <img src="assets/icon/personalizado/cloud.svg" alt="cloud_icon"
                          ngbTooltip="Pesquisar placa no Dim Cloud" (click)="buscarDimCloudPlaca()"
                          class="dim-cloud-icon ml-2 line-adjust" aria-hidden="true">
                      </div>
                    </div>
                  </div>

                  <div class="form-group col-sm-4">
                    <label for="form_marca" class="label-required">Marca</label>
                    <input id="form_marca" type="text" maxlength="20" class="form-control" formControlName="marca"
                      [disabled]="loading['request'] || loading['disabled']">
                    <show-errors [control]="formAuto.controls['marca']"></show-errors>
                  </div>

                  <div class="form-group col-sm-4">
                    <label for="form_modelo" class="label-required">Modelo</label>
                    <input id="form_modelo" type="text" maxlength="50" class="form-control" formControlName="modelo"
                      [disabled]="loading['request'] || loading['disabled']">
                    <show-errors [control]="formAuto.controls['modelo']"></show-errors>
                  </div>

                  <div class="form-group col-sm-4">
                    <label for="form_combustivel">Combustivel</label>
                    <input id="form_combustivel" type="text" maxlength="30" class="form-control"
                      formControlName="combustivel" [disabled]="loading['request'] ||loading['disabled']">
                  </div>

                  <div class="form-group col-sm-4">
                    <label for="form_ano_Fabricacao_Modelo" class="label-required">Ano de Fabricação/Modelo</label>
                    <input id="form_ano_Fabricacao_Modelo" type="text" maxlength="10" class="form-control"
                      formControlName="ano_Fabricacao_Modelo" [disabled]="loading['request'] || loading['disabled']"
                      mask="0000/0000">
                    <show-errors [control]="formAuto.controls['ano_Fabricacao_Modelo']"></show-errors>
                  </div>

                  <div class="form-group col-sm-4">
                    <label for="form_cor" class="label-required">Cor Predominante</label>
                    <input id="form_cor" type="text" maxlength="20" class="form-control" formControlName="cor"
                      [disabled]="loading['request'] || loading['disabled']">
                    <show-errors [control]="formAuto.controls['cor']"></show-errors>
                  </div>

                  <div class="form-group col-sm-4">
                    <label for="form_chassi">Chassi</label>
                    <input id="form_chassi" type="text" maxlength="17" class="form-control" formControlName="chassi"
                      [disabled]="loading['request'] || loading['disabled']">
                  </div>

                  <div class="form-group col-sm-4">
                    <label for="form_potencia">Potência</label>
                    <input id="form_potencia" type="text" maxlength="10" class="form-control" formControlName="potencia"
                      [disabled]="loading['request'] || loading['disabled']">
                  </div>

                  <div class="form-group col-sm-4">
                    <label for="form_motor">Motor</label>
                    <input id="form_motor" type="text" maxlength="21" class="form-control" formControlName="motor"
                      [disabled]="loading['request'] || loading['disabled']">
                  </div>

                  <div class="form-group col-sm-4">
                    <label for="form_categoria">Categoria</label>
                    <input id="form_categoria" type="text" maxlength="30" class="form-control"
                      formControlName="categoria" [disabled]="loading['request'] || loading['disabled']">
                  </div>

                  <div class="form-group col-sm-4">
                    <label for="form_capacidade">Capacidade</label>
                    <input id="form_capacidade" type="text" maxlength="20" class="form-control"
                      formControlName="capacidade" [disabled]="loading['request'] || loading['disabled']">
                  </div>
                </div>
              </form>
            </div>
            <div class="dim-tabswipe-content" *ngIf="tab === 'Logística' || appTab.loadingValidacoes">
              <div class="row">
                <div class="form-group col-sm-6">
                  <label for="form_almoxarifadoPadraoId" [appDimBoldText]="fieldRequired('almoxarifadoPadraoId')">
                    Almoxarifado
                  </label>
                  <ng-select id="form_almoxarifadoPadraoId" [appendTo]="appendTo" [loading]="loading['almoxarifados']"
                    placeholder="Selecione" [items]="almoxarifados" bindLabel="nome" bindValue="id"
                    formControlName="almoxarifadoPadraoId" [disableControl]="loading['request'] || loading['disable']">
                    <ng-template ng-option-tmp let-item="item">
                      <app-temp-option-item [name]="item.nome"
                        (onClick)="subscribeModal('almoxarifado'); abrirModal.editar('almoxarifado', item.id)">
                      </app-temp-option-item>
                    </ng-template>

                    <ng-template ng-notfound-tmp let-items="items" let-searchTerm="searchTerm">
                      <app-temp-not-found-item [searchTerm]="searchTerm"
                        (onClick)="subscribeModal('almoxarifado'); abrirModal.cadastrar('almoxarifado', searchTerm)">
                      </app-temp-not-found-item>
                    </ng-template>
                  </ng-select>
                  <show-errors [control]="form.controls['almoxarifadoPadraoId']"></show-errors>
                </div>
                <div class="form-group col-sm-2 lancar-estoque-div">
                  <button class="btn btn-sm btn-info ml-0 lancar-estoque-button" (click)="lancarEstoque()"
                    *ngIf="novoCadastro" type="button">
                    <i class="ti ti-new-window"></i> Lançar estoque
                  </button>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-sm-6">
                  <label for="form_linhaId" [appDimBoldText]="fieldRequired('linhaId')">
                    Linha
                  </label>
                  <ng-select id="form_linhaId" [appendTo]="appendTo" [loading]="loading['linhaProdutos']"
                    placeholder="Selecione" [items]="linhas" bindLabel="descricao" bindValue="id"
                    formControlName="linhaId" [disableControl]="loading['request'] || loading['disable']">
                    <ng-template ng-option-tmp let-item="item">
                      <app-temp-option-item [name]="item.descricao"
                        (onClick)="subscribeModal('linhaProduto'); abrirModal.editar('linhaProduto', item.id)">
                      </app-temp-option-item>
                    </ng-template>

                    <ng-template ng-notfound-tmp let-items="items" let-searchTerm="searchTerm">
                      <app-temp-not-found-item [searchTerm]="searchTerm"
                        (onClick)="subscribeModal('linhaProduto'); abrirModal.cadastrar('linhaProduto', searchTerm)">
                      </app-temp-not-found-item>
                    </ng-template>
                  </ng-select>
                  <show-errors [control]="form.controls['linhaId']"></show-errors>
                </div>
                <div class="form-group col-sm-6" *ngIf="getDynamicOption('estoqueMinimo')">
                  <label for="form_estoqueMinimo" [appDimBoldText]="fieldRequired('estoqueMinimo')">
                    Estoque mínimo
                    <i class="fa fa-info-circle tooltip-cest"
                      ngbTooltip="Você será alertado quando a quantidade desse produto for igual ou inferior ao valor informado aqui."
                      container="body" [autoClose]="true" triggers="manual" #t="ngbTooltip" (mouseleave)="t.close()"
                      (mouseenter)="t.open()" (click)="t.open()" aria-hidden="true"></i></label>
                  <input id="form_estoqueMinimo" class="form-control" placeholder="Estoque mínimo"
                    formControlName="estoqueMinimo"
                    [options]="{ prefix: '', thousands: '.', decimal: ',', precision: precisaoQuantidade }" currencyMask
                    inputmode="numeric" [disableControl]="loading['request'] || loading['disable']">
                  <show-errors [control]="form.controls['estoqueMinimo']"></show-errors>
                </div>
                <div class="form-group col-sm-6" *ngIf="getDynamicOption('indicadorTipoEstoque')">
                  <label for="form_indicadorTipoEstoque">Indicador Estoque (SPED)</label>
                  <ng-select id="form_indicadorTipoEstoque" [appendTo]="appendTo" formControlName="indicadorTipoEstoque"
                    placeholder="0 - Estoque de propriedade do informante e em seu poder"
                    [items]="selectIndicadorEstoque" bindLabel="descricao" bindValue="id"
                    [disableControl]="loading['request'] || loading['disable']">
                  </ng-select>
                  <show-errors [control]="form.controls['indicadorTipoEstoque']"></show-errors>
                </div>
                <div class="form-group col-sm-6" *ngIf="getDynamicOption('validadeEmDias')">
                  <label for="form_validadeEmDias" [appDimBoldText]="fieldRequired('validadeEmDias')">
                    Prazo de Validade (em dias)</label>
                  <input id="form_validadeEmDias" class="form-control" placeholder="Prazo de Validade"
                    formControlName="validadeEmDias" type="number" appOnlyNumbers
                    inputmode="numeric" [disableControl]="loading['request'] || loading['disable']">
                  <show-errors [control]="form.controls['validadeEmDias']"></show-errors>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-sm-12 col-md-6">
                  <label for="form_balancaId" class="label-required">Balança impressora de código de barras</label>
                  <ng-select id="form_balancaId" [appendTo]="appendTo" formControlName="balancaId" [items]="balancas"
                    bindLabel="descricao" bindValue="id" placeholder="Selecione uma balança"
                    [disableControl]="loading['request'] || loading['disable']">
                  </ng-select>
                  <show-errors [control]="formAuto.controls['estadoId']"></show-errors>
                </div>
                <div class="form-group col-sm-12 col-md-6">
                  <label for="form_codigoBalanca" [appDimBoldText]="fieldRequired('codigoBalanca')">
                    Código do produto na balança
                  </label>
                  <input id="form_codigoBalanca" class="form-control" placeholder="Código na balança"
                    [options]="{ prefix: '', thousands: '', decimal: '', precision: 0 }" type="text" currencyMask inputmode="numeric"
                    formControlName="codigoBalanca" [disableControl]="loading['request'] || loading['disable']">
                  <show-errors [control]="form.controls['codigoBalanca']"></show-errors>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-sm-6" *ngIf="getDynamicOption('observacoes')">
                  <label for="">Observações</label>
                  <textarea class="form-control" formControlName="observacoes" rows="4" style="min-height: 36px;"
                    maxlength="1000" (blur)="tratarObservacoes($event)"></textarea>
                  <show-errors [control]="form.controls['observacoes']"></show-errors>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-sm-12">
                  <div class="mb-2">
                    <span><b>Composição do item</b></span>
                    <button ngbTooltip="Adicionar um novo item filho" (click)="createViewItensComposicao()"
                      type="button" class="btn btn-info btn-outline-info btn-new-item ml-3">
                      <i class="fa fa-plus"></i>
                    </button>
                  </div>
                  <div *ngIf="form.get('itensComposicao').value.length < 0" class="jumbotron-cart jumbotron-itens">
                    <h4>Nenhum item filho informado!</h4>
                  </div>
                  <app-dim-datatable *ngIf="form.get('itensComposicao').value.length > 0" class="tabela-composicao"
                    [columns]="tabelaItensComposicaoColunas" [data]="form.get('itensComposicao').value" [acoes]="true">
                    <ng-template #buttonsMaxTmpl let-row="row" let-index="index">
                      <button type="button" (click)="createViewItensComposicao(row, index)"
                        class="btn btn-primary btn-mini waves-effect waves-light" placement="left" ngbTooltip="Editar">
                        <i class="icofont icofont-info"> </i>
                      </button>
                      <button type="button" (click)="removerItemFilho(index)"
                        class="btn btn-danger btn-mini waves-effect waves-light" placement="left" ngbTooltip="Remover">
                        <i class="ti ti-trash"></i>
                      </button>
                    </ng-template>
                    <ng-template #customTmpl let-row="row" let-column="column" let-index="index">
                      <ng-template [ngIf]="column === 'descricaoItem'">
                        <span>{{row.descricaoItem}}</span>
                      </ng-template>
                      <ng-template [ngIf]="column === 'quantidade'">
                        <span>{{ row.quantidade | number:'1.' + precisaoQuantidade + '-' +
                          precisaoQuantidade }}</span>
                      </ng-template>
                    </ng-template>
                  </app-dim-datatable>
                </div>
              </div>
            </div>
            <div class="dim-tabswipe-content" *ngIf="tab === 'Tabelas de preço' || appTab.loadingValidacoes">
              <div class="row">
                <div class="form-group col-sm-12" style="height: auto;">
                  <app-dim-datatable [data]="tabelasPrecosGrid" [columns]="tabelasPrecosColunas"
                    [totalItems]="tabelasPrecosGrid.length" [serverPaginated]='false' [loading]="loading['consulta']"
                    [acoes]="true" [rowsOnPage]="10000" *ngIf="tabelasPrecosGrid.length > 0" [showPagination]="false">

                    <ng-template #buttonsMaxTmpl #buttonMinTmpl let-row="row">
                      <button (click)="removerVinculo(row.id)" class="btn btn-danger btn-mini waves-effect waves-light"
                        placement="left" ngbTooltip="Excluir">
                        <i class="ti ti-trash"> </i>
                      </button>
                    </ng-template>
                  </app-dim-datatable>

                  <div *ngIf="tabelasPrecosGrid.length === 0" class="tblPrecoEmpty">
                    Nenhuma tabela de preço vinculada a este produto!&nbsp;<i class="ti-help-alt helpIcon"
                      style="cursor: pointer;" (click)="clickHelpTabelaPreco()"
                      ngbTooltip="Precisa de Ajuda?" placement="left" aria-hidden="true"></i>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-sm-6">
                  <label for="form_tabelasPrecoSelecionada">
                    Tabela de Preço
                  </label>
                  <ng-select id="form_tabelasPrecoSelecionada" [appendTo]="appendTo" [loading]="loading['tabelasPreco']"
                    placeholder="Selecione" [items]="tabelasPrecoDisponiveis" bindLabel="nome" bindValue="id"
                    [(ngModel)]="tabelasPrecoSelecionada" [ngModelOptions]="{standalone: true}"
                    [disableControl]="loading['tabelasPreco'] || loading['request'] || loading['disable']">
                    <ng-template ng-option-tmp let-item="item">
                      <app-temp-option-item [name]="item.nome"
                        (onClick)="subscribeModal('tabelasPreco'); abrirModal.editar('tabelasPreco', item.id)">
                      </app-temp-option-item>
                    </ng-template>

                    <ng-template ng-notfound-tmp let-items="items" let-searchTerm="searchTerm">
                      <app-temp-not-found-item [searchTerm]="searchTerm"
                        (onClick)="subscribeModal('tabelasPreco'); abrirModal.cadastrar('tabelasPreco', searchTerm)">
                      </app-temp-not-found-item>
                    </ng-template>
                  </ng-select>
                </div>
                <div class="form-group col-sm-4">
                  <label for="form_tabelasPrecoSelecionadaPreco">
                    Preço
                  </label>
                  <input id="form_tabelasPrecoSelecionadaPreco"
                    [disableControl]="loading['request'] || loading['disable']"
                    [options]="{ prefix: '', thousands: '.', decimal: ',', precision: precisaoQuantidade }" currencyMask
                    inputmode="numeric" class="form-control" type="text" [(ngModel)]="tabelasPrecoSelecionadaPreco"
                    [ngModelOptions]="{standalone: true}" placeholder="Preço na tabela selecionada">
                </div>
                <div class="form-group col-sm-2">
                  <label for="" style="display: block;">&nbsp;</label>
                  <button class="btn btn-sm btn-info ml-0 mb-2" (click)="vincular()" type="button">
                    Vincular tabela
                  </button>
                </div>
              </div>
              <div class="alert alert-danger" *ngIf="tabelasPrecoError">
                <span>{{tabelasPrecoError}}</span>
              </div>
            </div>
            <div class="dim-tabswipe-content"
              *ngIf="(tab === 'Agenda' || appTab.loadingValidacoes) && (form.get('servicoProduto').value === 'S') && horarioInicial && horarioFinal">
              <div class="row mb-2 d-flex justify-content-center">
                <div class="col-sm-8">
                  <div class="row">
                    <div class="form-group col-sm-4">
                      <span>Intervalo</span>
                      <app-time formControlName="cargaMinutosAgenda" [parseToInt]="true"
                        (change)="horariosForm.markAsPristine()" [disabled]="loading['horarios']"></app-time>
                    </div>
                    <div class="form-group col-sm-4">
                      <span>Data</span>
                      <app-data [(ngModel)]="data" [ngModelOptions]="{standalone: true}" (change)="dateChange()"
                        [disabled]="loading['horarios']"></app-data>
                    </div>
                    <div class="form-group col-sm-4">
                      <span style="display: block;">&nbsp;</span>
                      <button class="btn btn-sm btn-info" style="width: 100%" (click)="calcularHorarios()"
                        *ngIf="horariosForm.pristine || !this.id" type="button">
                        Consultar agenda
                      </button>
                      <button class="btn btn-sm btn-primary" style="width: 100%" (click)="salvarHorarios()"
                        *ngIf="!horariosForm.pristine && this.id" type="button">
                        Salvar agenda
                      </button>
                    </div>
                  </div>
                  <div class="row" *ngIf="form.get('nome').value.length > 0">
                    <div class="form-group col-sm-12">
                      <span><b>Descrição do serviço</b></span><br>
                      <span>{{form.get('nome').value}}</span>
                    </div>
                  </div>
                  <div class="row" [formGroup]="horariosForm">
                    <div class="table-responsive col-sm-12" *ngIf="horarios">
                      <div class="datatable-loading" *ngIf="loading['horarios']">
                        <div class="datatable-loader"></div>
                      </div>
                      <table class="table table-bordered table-striped horarios-table">
                        <thead>
                          <tr>
                            <th style="width: 80px">Horário</th>
                            <th>Cliente</th>
                            <th style="width: 70px;">Ações</th>
                          </tr>
                        </thead>
                        <tbody>
                          <ng-container *ngFor="let horario of $any(horarios).controls">
                            <tr [formGroup]="horario">
                              <td>{{formatarHorario(horario.value.periodo)}}</td>
                              <td class="coluna-cliente" style="width: 100%;">
                                <div style="max-width: 100%;" class="form-group col-sm-12" placeholder="Livre" rem5
                                  combobox [type]="'cliente'" [showLabel]="false" [loading]="loading" [form]="form"
                                  formControlName="clienteId">
                                </div>
                              </td>
                              <td class="text-center">
                                <button type="button" class="btn btn-primary btn-mini"
                                  (click)="replicarHorario(horario.value)" [disabled]="!horario.value.clienteId"
                                  ngbTooltip="Replicar" placement="top">
                                  <i class="fa fa-clone"></i>
                                </button>
                              </td>
                            </tr>
                          </ng-container>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="dim-tabswipe-content" *ngIf="tab === 'RelacionamentosCustomTab' || appTab.loadingValidacoes">
              <ng-container *ngIf="itemInicial?.itensFornecedores?.length > 0 && !adicionandoItemFornecedor">
                <app-dim-datatable [loading]="loading['disable'] || loading['request'] || loadingRelaciomanetos" [rowsOnPage]="10"
                  [data]="itemInicial?.itensFornecedores || []" [columns]="tabelaRelacionamentosColunas"
                  [acoes]="true">
                  <ng-template #buttonsMaxTmpl #buttonMinTmpl let-row="row">
                    <button type="button" (click)="removerRelacionamento(row.id)" class="btn btn-danger btn-mini waves-effect waves-light"
                      placement="left" ngbTooltip="Remover relacionamento" [disabled]="loading['removerRelacionamento'] || loadingRelaciomanetos">
                      <i class="ti ti-trash"> </i>
                    </button>
                  </ng-template>
                </app-dim-datatable>

                <div class="row m-0">
                  <button type="button" class="btn btn-info waves-effect waves-light" (click)="adicionarRelacionamento()">
                    <i class="fa fa-plus"></i>
                    Adicionar relacionamento
                  </button>
                </div>
              </ng-container>
              <ng-container *ngIf="itemInicial?.itensFornecedores?.length === 0 && !adicionandoItemFornecedor">
                <div class="text-center">
                  Nenhum relacionamento encontrado
                  <br>
                  <button type="button" style="border-radius: calc(infinity * 1px)" class="btn btn-info waves-effect waves-light mt-2" (click)="adicionarRelacionamento()">
                    Adicionar relacionamento
                  </button>
                </div>
              </ng-container>
              <ng-container *ngIf="adicionandoItemFornecedor">
                <form [formGroup]="formItemFornecedor" (ngSubmit)="adicionarItemFornecedor()">
                  <div class="row">
                    <div class="form-group col-sm-6">
                      <div combobox rem5 type="fornecedor" formControlName="fornecedorId" [loading]="loading" (change)="buscaItensFornecedor('')"></div>
                      <show-errors [control]="formItemFornecedor.controls['fornecedorId']"></show-errors>
                    </div>

                    <div class="form-group col-sm-6">
                      <label for="form_itemFornecedorId">Itens do Fornecedor ({{getSelectedOption()}})
                        <div ngbDropdown class="btn-group dropdown-split-primary" style="margin-right: 6px; display: inline-block; margin-top: 0px;">
                          <button type="button" ngbDropdownToggle id="optionsCombo" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" 
                            style="margin: 0px;" class="btn btn-mini btn-primary dropdown-toggle dropdown-toggle-split waves-effect waves-light">
                          </button>
                          <div ngbDropdownMenu placement="bottom-right" class="dropdown-menu">
                            <a class="dropdown-item waves-effect waves-light" *ngFor="let op of selectOptions.options; index as index" 
                              (click)="alteraOption(index)">
                              <i *ngIf="selectOptions.opSelecionado === index" class="cr-icon icofont icofont-ui-check txt-default" 
                                style="font-size: 8px; margin-left: -13px!important;" >
                              </i>
                              {{op.value}}
                            </a>
                          </div>
                        </div>
                        <i class="fa fa-question-circle" style="cursor: pointer" ngbTooltip="Necessário informar o fornecedor."></i>
                      </label>
                      <ng-select #itensFornecedoresSelect [loading]="loadingRelaciomanetos" [readonly]="loadingRelaciomanetos || !this.formItemFornecedor.value.fornecedorId"
                        formControlName="itemFornecedorId" [virtualScroll]="true" [items]="itensFornecedor" placeholder="Selecione"
                        bindValue="id" bindLabel="nome" (scrollToEnd)="buscaItensFornecedor(itensFornecedoresSelect.searchTerm || '', null, true)"
                        [typeahead]="filtroItensFornecedor" id="form_itemFornecedorId" appendTo="body">
                        <ng-template ng-option-tmp ng-label-tmp let-item="item">
                          {{selectItensFornecedorDescricao(item)}}
                        </ng-template>
                      </ng-select>
                      <show-errors [control]="formItemFornecedor.controls['itemFornecedorId']"></show-errors>
                    </div>
                  </div>

                  <div class="form-button-row">
                    <button type="submit" hiddenMenu class="btn btn-info" [disabled]="loadingRelaciomanetos">
                      <app-loading [loading]="loading['adicionandoItemFornecedor']" icone="fa fa-plus" [texto]="'Adicionar relacionamento'" [textoLoading]="'Adicionando...'"/>
                    </button>
                    <button type="button" class="btn btn-danger" (click)="cancelarAdicaoItemFornecedor()" [disabled]="loading['adicionandoItemFornecedor']">
                      <i class="fa fa-times"></i>
                      Cancelar
                    </button>
                  </div>
                </form>
              </ng-container>
            </div>
            <div class="dim-tabswipe-content" *ngIf="tab === 'Fotos' || appTab.loadingValidacoes">
              <div [ngStyle]="{'display': (this.enviarImagem) ? 'block' : 'none'}">
                <image-cropper #imageCropper *ngIf="imageCropperImage" style="max-width: 100vw; max-height: 60vh;"
                  [autoCrop]="false" [format]="imageCropperImageType || 'png'" [canvasRotation]="canvasRotation"
                  [transform]="transform" [maintainAspectRatio]="false" [imageBase64]="imageCropperImage"
                  (imageLoaded)="imageLoaded()"></image-cropper>
                <div *ngIf="!imageCropperImage" style="display: flex; justify-content: center; align-items: center;">
                  Envie uma foto para continuar
                </div>
                <div *ngIf="imageCropperImage" class="row justify-content-center mt-2">
                  <button type="button" class="btn btn-info btn-sm waves-effect waves-light" (click)="rotateLeft()"
                    ngbTooltip="Girar para esquerda">
                    <i class="fa fa-rotate-left"> </i>
                  </button>
                  <button type="button" class="btn btn-info btn-sm waves-effect waves-light" (click)="rotateRight()"
                    ngbTooltip="Girar para direita">
                    <i class="fa fa-rotate-right"> </i>
                  </button>
                </div>
                <div class="row justify-content-center my-2">
                  <div class="col-12 text-center">
                    <input #file id="selectedFile" type="file" accept=".jpg,.png,.jpeg"
                      (change)="fileChangeEvent(file.files)" style="display: none;" />
                    <button type="button" class="btn btn-info"
                      onclick="document.getElementById('selectedFile').click();">
                      <i class="fa fa-upload"></i> Carregar Foto
                    </button>
                    <button *ngIf="imageCropperImage" type="button" class="btn btn-primary" (click)="cropImage()">
                      <i class="fa fa-check"></i> Confirmar
                    </button>
                    <button type="button" class="btn btn-danger" (click)="voltarGaleria()">
                      <i class="ti ti-close"></i> Cancelar
                    </button>
                  </div>
                </div>
              </div>
              <div *ngIf="!this.enviarImagem">
                <button type="button" style="margin: 0 15px 0 0;" class="btn btn-primary custom-form-button"
                  [disabled]="itensFotos.length >= 5" (click)="habilitaCropper()">
                  <app-loading texto="Carregar Foto" icone="ti ti-plus" [loading]="loading['salvando']"></app-loading>
                </button>
                <span style="color: #9f9f9f;
                              font-size: 13px;">Armazene até 5 fotos do seu produto.
                </span>
                <app-produto-galeria [carregando]="itensFotosCarregando" [listaImagem]="itensFotos"
                  (onEdit)="handleGaleryOnEdit($event)" (onFavorite)="handleGaleryOnFavorite($event)"
                  (onDelete)="handleGaleryOnDelete($event)"
                  (onRevert)="handleGaleryOnRevert($event)"></app-produto-galeria>
              </div>
            </div>
          </mat-tab>
        </mat-tab-group>

        <div class="alert alert-danger" *ngIf="errors && errors.length > 0">
          <span *ngFor="let error of errors">{{ error }}</span>
        </div>

        <div class="form-button-row mt-3" [ngStyle]="{'display': mostraBotoesProduto ? 'block' : 'none'}">
          <button class="btn btn-primary custom-form-button submit-form" (click)="validaForm()" [disabled]="loading['request'] || loading['salvando']
                            || (this.acoesTela && (novoCadastro && !this.acoesTela['cadastro']?.acesso)
                              || (!novoCadastro && this.acoesTela && !this.acoesTela['editar']?.acesso))">
            <app-loading texto="Salvar" textoLoading="Salvando" icone="ti ti-save"
              [loading]="loading['salvando']"></app-loading>
          </button>
          <button class="btn btn-danger custom-form-button" (click)="excluir(id)"
            *ngIf="!novoCadastro && !cadastroFactory" type="button"
            [disabled]="loading['request'] || loading['deletando'] || (this.acoesTela && !this.acoesTela['excluir']?.acesso)">
            <app-loading texto="Excluir" textoLoading="Excluindo" icone="ti ti-trash"
              [loading]="loading['deletando']"></app-loading>
          </button>
          <button class="btn btn-info custom-form-button"
            [routerLink]="['/suprimentos/cadastros/produtos/comissoes/', id]" *ngIf="!novoCadastro && !dentroModal" type="button"
            [disabled]="loading['request']
                                  || (!novoCadastro && this.acoesTela && !this.acoesTela['editar']?.acesso)">
            <i class="ti-money"></i> Comissões
          </button>
          <button class="btn btn-info custom-form-button" (click)="voltar()" type="button" *ngIf="!cadastroFactory">
            <i class="ti-back-left"></i> Voltar
          </button>
          <button class="btn btn-info custom-form-button" (click)="finalizeFactory()" *ngIf="cadastroFactory"
            type="button" [disabled]="loading['request']">
            <i class="icofont icofont-close-circled"></i> Cancelar
          </button>
        </div>

      </form>
    </app-dim-tabswipe>
  </app-card>
</div>
<template #itensComposicaoContainer></template>
<app-abrir-modal #abrirModal></app-abrir-modal>